import React from "react";
import classNames from "classnames";
import { RequestStatus } from "../../../../types/mydata";
import { Typography } from "../../../../components/__common/Typography/Typography";

interface StepsProps {
  status: RequestStatus;
}

export const Steps: React.FC<StepsProps> = (props) => {
  const { status } = props;
  const allowedStatuses = [RequestStatus.COMPLETED, RequestStatus.PROCESSING];

  // Step 1: PROCESSING, Step 2: COMPLETED
  const stepOneValue = status === RequestStatus.PROCESSING ? 1 : "";
  const stepTwoValue = status === RequestStatus.COMPLETED ? 2 : "";

  return (
    <>
      {allowedStatuses.includes(status) && (
        <div className="request-details__steps">
          <Typography
            variant="body3"
            className={classNames("request-details__steps__step", {
              active: status === RequestStatus.PROCESSING,
              prev: status === RequestStatus.COMPLETED,
            })}
          >
            {stepOneValue}
          </Typography>

          <Typography
            variant="body3"
            className={classNames("request-details__steps__step", {
              active: status === RequestStatus.COMPLETED,
            })}
          >
            {stepTwoValue}
          </Typography>
        </div>
      )}
    </>
  );
};
